export default __webpack_public_path__ + "static/media/SLSTM2.87ffcdf1.png";